<div class="overlay" *ngIf="isVisible$ | async" (click)="overlayClicked()"></div>
